import { setDerivePbkdf2KeyImpl } from '@mysimpledb/shared/utils/crypto/vaultKeyDerivation';
import {
  setVaultRandomBytesImpl,
  ensureUint8Array,
} from '@mysimpledb/shared/utils/crypto/vaultCryptoUtils';

function getWebCrypto() {
  const cryptoObj = globalThis.crypto;
  if (!cryptoObj?.subtle) {
    throw new Error('Web Crypto API is not available in this browser');
  }
  return cryptoObj;
}

async function derivePbkdf2KeyWeb({
  passphraseBytes,
  saltBytes,
  iterations,
  keyBytes,
}) {
  const cryptoObj = getWebCrypto();

  const baseKey = await cryptoObj.subtle.importKey(
    'raw',
    ensureUint8Array(passphraseBytes),
    'PBKDF2',
    false,
    ['deriveBits']
  );

  const derivedBits = await cryptoObj.subtle.deriveBits(
    {
      name: 'PBKDF2',
      hash: 'SHA-256',
      salt: ensureUint8Array(saltBytes),
      iterations,
    },
    baseKey,
    keyBytes * 8
  );

  const derivedKeyBytes = new Uint8Array(derivedBits);

  return derivedKeyBytes;
}

function getRandomBytesWeb(length) {
  const cryptoObj = getWebCrypto();
  const out = new Uint8Array(length);
  cryptoObj.getRandomValues(out);
  return out;
}

let registered = false;

export function registerVaultCryptoWeb() {
  if (registered) {
    return;
  }

  setDerivePbkdf2KeyImpl(derivePbkdf2KeyWeb);
  setVaultRandomBytesImpl(getRandomBytesWeb);

  registered = true;
}
